<template>
  <div class="app">
    <template v-if="initialized">
      <app-header />
      <div class="app__page" role="main">
        <loader-cubics v-if="loading" v-slot:text wrapper-css-class="_fixed">
          Загрузка данных...
        </loader-cubics>
        <div v-else-if="loadingError" class="error-page message _xl _error">
          {{ loadingError.message }}
        </div>
        <router-view v-else />
      </div>
      <app-footer />
      <app-notifications-wrapper />
    </template>
    <div v-else-if="loadingError" class="error-page message _xl _error">
      {{ loadingError.message }}
    </div>
    <loader-cubics v-else v-slot:text wrapper-css-class="_fixed">
      Загрузка приложения...
    </loader-cubics>
  </div>
</template>

<script>
import LoaderCubics from '@@/shared/loaders/LoaderCubics';
import AppHeader from '@@/header/Header.vue';
import AppFooter from '@@/layout/Footer';
import AppNotificationsWrapper from '@@/shared/notifications/Wrapper';
import { ROUTE_HOME, ROUTE_LOGIN } from '@src/routes';

export default {
  name: 'App',
  components: {
    LoaderCubics,
    AppHeader,
    AppFooter,
    AppNotificationsWrapper
  },

  data: () => ({
    authChecked: false
  }),

  computed: {
    initialized() {
      return this.$store.state.initialized && this.authChecked;
    },

    loading() {
      return this.$store.state.loading;
    },

    loadingError() {
      return this.$store.state.loadingError;
    },

    userIsAuthenticated() {
      return this.$store.state.auth.user.isAuthenticated;
    }
  },

  watch: {
    userIsAuthenticated(authenticated) {
      if (authenticated) {
        if (this.$route.name === ROUTE_LOGIN) {
          this.$router.push(this.$route.query.to || { name: ROUTE_HOME });
        }
      } else {
        this.redirectToLogin();
      }
    }
  },

  created() {
    window.addEventListener('resize', this.updateWindowSize);
    this.$store.dispatch(
      'setOpenInWindowAction',
      localStorage.getItem('openInWindow')
    );
    this.$router.beforeEach((to, from, next) => {
      if (this.userIsAuthenticated || to.name === ROUTE_LOGIN) {
        next();
      } else {
        next(false);
      }
    });

    this.$store
      .dispatch('initApplication')
      .then(() => {
        this.$store.dispatch('startSyncWindows').finally(() => {
          this.$store.dispatch('authCheck', 'init').finally(() => {
            if (!this.userIsAuthenticated) {
              this.redirectToLogin(this.$route.fullPath);
            }
            this.authChecked = true;
          });
        });
      })
      .catch(error => console.error(error));
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.updateWindowSize);
  },

  methods: {
    updateWindowSize() {
      this.$store.dispatch('setWindowSize', window.innerWidth);
    },

    redirectToLogin(to = null) {
      if (this.$route.name !== ROUTE_LOGIN) {
        this.$router.push({
          name: ROUTE_LOGIN,
          query: to ? { to } : null
        });
      }
    }
  },

  metaInfo: {
    title: 'Сетевая версия',
    titleTemplate: '%s • NormaCS'
  }
};
</script>
